import { Text, MultilineText } from './Text';
import { Boolean } from './Boolean';
import { Actions } from './Actions';
import { Link } from './Link';
import { Buttons } from './Buttons';
import { MediaViewer } from './MediaViewer';

export const Columns = { Text, MultilineText, Boolean, Actions, Link, Buttons, MediaViewer };
